import React, { Dispatch, useMemo } from 'react';
import classes from './PostCategoryFilterGroup.module.scss';
import { FilterItem } from '../FilterItem';
import { CoreCategoryFieldsFragment, PostQueueCountResult } from '../../../models/graphql';
import classNames from 'classnames';
import { PostScheduleFilterAction } from '../../../models/post';
import { FilterItemGroup } from '../FilterItemGroup';
import { PostScheduleHelpers } from '../../../modules/Publish/PostSchedule/postScheduleHelpers';
import { Debugger } from '../../containers/Debugger';

export type PostCategoryFilterGroupViewProps = {
  categories: CoreCategoryFieldsFragment[];
  loading: boolean;
  dispatchFilters: Dispatch<PostScheduleFilterAction>;
  activeFilterId?: string;
  queueCounts: PostQueueCountResult;
};

export const PostCategoryFilterGroupView = (props: PostCategoryFilterGroupViewProps): JSX.Element => {
  const { queueCounts } = props; // useContext(QueueCountContext);
  const setSelectedFilter = (id: string) => {
    props.dispatchFilters({ type: 'category', payload: { data: id, fetchPosts: true } });
  };
  const counts = useMemo(() => PostScheduleHelpers.getQueueCounts(queueCounts, 'categories'), [queueCounts]);

  const filterClasses = classNames(
    'grid-x',
    'grid-padding-x',
    'align-left',
    classes.PostCategoryFilterGroup,
    'align-middle'
  );

  const filterItems = props.categories.map(cat => {
    const categoryClasses = classNames(classes.ColorBar, classes[`ColorBar${cat.color}`]);

    return (
      <FilterItem
        key={`categoryFilter.${cat.id}`}
        count={counts[cat.id] ?? 0}
        selected={props.activeFilterId === cat.id}
        loading={props.loading}
        setSelectedHandler={() => setSelectedFilter(cat.id)}>
        <div className={'relative'}>
          <Debugger tooltipContent={'Category ID: ' + cat.id} modalContent={cat} />
        </div>
        <div className={filterClasses}>
          <div className={categoryClasses} />
          <div className={`cell shrink ${classes.Label}`}>{cat.name}</div>
        </div>
      </FilterItem>
    );
  });

  return <FilterItemGroup title={'Filter By Category'}>{filterItems}</FilterItemGroup>;
};
